import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//import components
import { CustomerComponent } from './components/customer.component';
import { ErrorComponent } from './components/error.component';
import { AuthComponent } from './components/auth.component';
import { AdminPanelComponent } from './components/admin-panel.component';
import { MainPanelComponent } from './components/main-panel.component';
import { RoleComponent } from './components/role.component';
import { UserComponent } from './components/user.component';
import { EmployeeComponent } from './components/employee.component';
import { ProductsPanelComponent } from './components/products-panel.component';
import { WarehouseComponent } from './components/warehouse.component';
import { ProductComponent } from './components/product.component';
import { InventaryComponent } from './components/inventary.component';
import { ServiceComponent } from './components/service.component';
import { ContractComponent } from './components/contract.component';
import { CorePanelComponent } from './components/core-panel.component';
import { HeaderWebComponent } from './components/header.component';
import { FooterWebComponent } from './components/footer.component';
import { PrinterComponent } from './components/printer.component';
import { TicketComponent } from './components/ticket.component';
import { AccountComponent } from './components/account.component';
import { SearchTicketsComponent } from './components/search-tickets.component';
import { EventComponent } from './components/event.component';


// Defines Routes
const appRoutes: Routes = [
  {path:'',component:AuthComponent},
  {path:'clientes',component:CustomerComponent},
  {path:'roles',component:RoleComponent},
  {path:'usuarios',component:UserComponent},
  {path:'empleados',component:EmployeeComponent},
  {path:'menu-admin',component:AdminPanelComponent},
  {path:'menu-productos',component:ProductsPanelComponent},
  {path:'menu-principal',component:MainPanelComponent},
  {path:'menu-core',component:CorePanelComponent},
  {path:'almacenes',component:WarehouseComponent},
  {path:'productos',component:ProductComponent},
  {path:'inventario',component:InventaryComponent},
  {path:'servicios',component:ServiceComponent},
  {path:'contratos',component:ContractComponent},
  {path:'impresion',component:PrinterComponent},
  {path:'ticket/:id/:customer_name',component:TicketComponent},
  {path:'account/:id',component:AccountComponent},
  {path:'buscar-tickets',component:SearchTicketsComponent},
  {path:'incidencia/:contract_id',component:EventComponent},
  {path:'**',component:ErrorComponent}
];



export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/app.routing.ts